import { QueryField } from './query-field';

export class QueryFields {

  private fields: QueryField[];

  constructor() {
    this.fields = [];
  }

  public add(field: QueryField) {
    this.fields.push(field);
  }

  public get(fieldName: string) {
    return this.fields.find(field => field.fieldName === fieldName);
  }

  public list(): QueryField[] {
    return this.fields;
  }

  public delete(fieldName: string) {
    let i = -1;
    for (i = 0; i < this.fields.length; i++) {
      if (this.fields[i].fieldName == fieldName)
        break;
    }
    if (i != -1)
      this.fields.splice(i, 1);
  }
}
